import axios from '../../http_v2'
export default {
  // 定制报表
  list: (params) => {
    return axios.get('activityservice/statistics/orgunit/tree', params)
  },
  save: (params) => {
    return axios.post('activityservice/statistics/orgunit/save', params)
  },
  del: (params) => {
    return axios.post('activityservice/statistics/orgunit/delete', params)
  },
  info: (params) => {
    return axios.get('activityservice/statistics/orgunit/info', params)
  },
  // 活动统计-场次分析
    // 活动举办场次统计
    count: (params) =>{
      return axios.post('activityservice/statistics/activity/count', params)
    },
    // 活动形式分析
    showway: (params) =>{
      return axios.post('activityservice/statistics/activity/showway', params)
    },
    // 参会人数分析
    showum: (params) =>{
      return axios.post('activityservice/statistics/activity/showwayprticipant', params)
    },
    // 活动类型分析
    activitytype: (params) =>{
      return axios.post('activityservice/statistics/activity/activitytype', params)
    },
    // 按报表组织统计活动场次
    orgUnit:(params) => {
      return axios.post('activityservice/statistics/activity/orgunit', params)
    },
  // 活动统计-人数分析
    // 报名人数分析
    prticipant: (params) =>{
      return axios.post('activityservice/statistics/activity/orgunit/prticipant', params)
    },
    // 直播观看量分析
    livepv: (params) =>{
      return axios.post('activityservice/statistics/activity/orgunit/prticipant/livepv', params)
    },
    // 线下参会人树分析
    prticdown: (params) =>{
      return axios.post('activityservice/statistics/activity/orgunit/prticipant/down', params)
    },
}